import classNames from 'classnames';
import { useState } from 'react';

import useFormatImageUrl from '../../hooks/useFormatImageUrl';
import getImageSize from '../../lib/getImageSize';

import Blocks from '../../components/blocks/Blocks';
import SubscriptionForm from '../../components/forms/SubscriptionForm';
import Body from '../../components/typography/Body';

import styles from './results.module.css';

interface SurveyResultsProps {
    title?: string;
    image?: Image;
    blocks?: Block[];
    form?: Form | null;
    subscriptions?: string[] | null;
    placeholder?: boolean;
    onIdentify?: (user: User) => void;
    className?: string;
}

function SurveyResults({
    title,
    image = null,
    blocks = null,
    form = null,
    subscriptions = null,
    placeholder = false,
    className,
}: SurveyResultsProps) {
    const formatImageUrl = useFormatImageUrl();
    const {
        url: imageUrl = null,
        width: imageWidth,
        height: imageHeight,
    } = getImageSize(image, 'large') || image || {};
    const { id: formId = null } = form || {};
    const [subscriptionCompleted, setSubscriptionCompleted] = useState(false);
    const onSubscriptionComplete = () => {
        setSubscriptionCompleted(true);
    };
    const imageShouldCover =
        imageWidth !== null && imageHeight !== null && Math.abs(imageWidth / imageHeight) - 1 > 0.5;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.imageShouldCover]: imageShouldCover,
                },
                className,
            ])}
        >
            <div className={styles.inner}>
                {imageUrl !== null || placeholder ? (
                    <div className={styles.imageContainer}>
                        {placeholder ? (
                            <div className={styles.placeholderImage} />
                        ) : (
                            <img
                                src={formatImageUrl(imageUrl)}
                                alt={title}
                                className={styles.image}
                                width={imageWidth}
                                height={imageHeight}
                            />
                        )}
                    </div>
                ) : null}
                <div className={styles.content}>
                    <Body className={styles.body}>
                        <Blocks
                            blocks={
                                placeholder
                                    ? [{ type: 'placeholder', maxCharacters: 30 }]
                                    : blocks || []
                            }
                            withoutMaxWidth
                        />
                    </Body>
                    {subscriptions !== null && subscriptions.length > 0 ? (
                        <SubscriptionForm
                            subscriptions={subscriptions}
                            full
                            withoutOtherSubscriptions={!subscriptionCompleted}
                            source="survey"
                            ssoSize="large"
                            withoutButtons
                            className={styles.subscriptions}
                            onComplete={onSubscriptionComplete}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default SurveyResults;
